import {Route, RouteConfig} from "vue-router";
const AccountsList = () => import('../views/accounts/AccountsList.vue');
const AccountsView = () => import('../views/accounts/AccountsView.vue');

let accounts: RouteConfig[] = [
    {
        name: 'accounts',
        path: '/accounts',
        component: AccountsList,
    },
    {
        name: 'accounts-view',
        path: '/accounts/view/:id/:type',
        component: AccountsView,
        props(route: Route)
        {
            return {
                id: String(route.params.id),
                type: route.params.type,
            };
        },
    },
];

export default accounts;
